import Skeleton from '@/common/components/skeleton/Skeleton';
import {
	List,
	ListItemSkeleton,
	ListItemSkeletonInfo,
} from '../conversationList.styles';

const SKELETON_ITEMS = [
	{ nameWidth: '68%', previewWidth: '82%' },
	{ nameWidth: '54%', previewWidth: '74%' },
	{ nameWidth: '72%', previewWidth: '88%' },
	{ nameWidth: '48%', previewWidth: '66%' },
	{ nameWidth: '64%', previewWidth: '78%' },
	{ nameWidth: '58%', previewWidth: '70%' },
];

const ConversationListSkeleton = () => (
	<List aria-hidden="true">
		{SKELETON_ITEMS.map((item, index) => (
			<ListItemSkeleton key={index}>
				<Skeleton
					width="50px"
					height="50px"
					minWidth="50px"
					minHeight="50px"
					radius="50%"
				/>
				<ListItemSkeletonInfo>
					<Skeleton width={item.nameWidth} height="14px" radius="6px" />
					<Skeleton width={item.previewWidth} height="12px" radius="6px" />
				</ListItemSkeletonInfo>
			</ListItemSkeleton>
		))}
	</List>
);

export default ConversationListSkeleton;
